import { render } from "./PortalChildSubTemplateCommon.vue?vue&type=template&id=1271efe7&scoped=true"
import script from "./PortalChildSubTemplateCommon.vue?vue&type=script&lang=js"
export * from "./PortalChildSubTemplateCommon.vue?vue&type=script&lang=js"

import "./PortalChildSubTemplateCommon.vue?vue&type=style&index=0&id=1271efe7&scoped=true&lang=css"

import exportComponent from "/runner/_work/cb-checkout/cb-checkout/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1271efe7"]])

export default __exports__